import React from 'react'
import { useIntl } from 'react-intl'

export const CsLoginLogo = () => {
  const { formatMessage } = useIntl()

  return (
    <div className="cs-login-logo">
      <img
        className="cs-logo"
        src="images/logos/cs_logo_white.svg"
        alt={formatMessage({ id: 'title_contrastSecurity' })}
      />
    </div>
  )
}
